import React, { useEffect, useState } from 'react';
import styles from './header.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faM , faHouseChimney, faAddressCard, faTrophy, faImages, faMessage } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames';
import { Link } from 'react-scroll';
import { HiChatAlt2 } from "react-icons/hi"
import { FaMoon } from "react-icons/fa"
import { BsFillSunFill } from "react-icons/bs"

export default function Header({darkMode, setDarkMode, currentProject}) {
    const DarkModeTextColorPrimary = darkMode ? '#FFFFFF' : '#4d4d4d';
    const [hoverEffect, setHoverEffect] = useState(false);
    const [headerScroll , setHeaderScroll] = useState(false);
    const [activeSection, setActiveSection] = useState("");
    const [tradeTheme, setTradeTheme] = useState(false);
    const [activeNavBar, setActiveNavBar] = useState(false);

    const handleSetActiveSection = (sectionId) => {
        setActiveSection(sectionId);
      };

    const onMouseEnterEffect = () => {
        setHoverEffect(true)
    }
    
    const onMouseLeaveEffect = () => {
        setHoverEffect(false)
    }

    const headerSticky = () => {
        if (window.scrollY >= 50){
            setHeaderScroll(true)
        } else {
            setHeaderScroll(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', headerSticky);
    
        
        return () => {
        window.removeEventListener('scroll', headerSticky);
        };
    }, []);

    const calcHoverColor = () => {
        if (darkMode) {
          return hoverEffect ? "#4d4d4d" : "#fff";
        } else {
          return hoverEffect ? "#fff" : "#4d4d4d";
        }
      };

    return (
        <section>
            <header style={{background:  currentProject ? 'transparent' : '', pointerEvents: currentProject ? 'none' : '',}} className={classNames(styles.container, headerScroll && !currentProject && !darkMode ? styles.containerHeaderScroll : '', headerScroll && !currentProject && darkMode ? styles.containerHeaderScrollDarkMod : '' )} >
                    <aside>
                        <nav className={styles.container_division}>
                        <div className={styles.container_logo}>
                            <FontAwesomeIcon className={styles.logo} icon={faM} size="2xs" style={{ color: DarkModeTextColorPrimary, border: darkMode ? '3px solid #ffffff' : ''}} />
                            
                            <span className={styles.logo2} style={{color: DarkModeTextColorPrimary}}>
                                Marcos Maio 
                            </span>
                            
                            {!tradeTheme && (
                                <FaMoon className={classNames( darkMode ? styles.tradeAnimation : '', styles.tradeTheme)} style={{marginLeft: '0.8em', color: '#4d4d4d', cursor: 'pointer'}} 
                                onClick={() => {
                                    setDarkMode(!darkMode)
                                    setTimeout(() => {
                                        setTradeTheme(true);
                                    }, 1000);
                                    }}
                                />
                            )}

                            {tradeTheme && (
                                <BsFillSunFill className={classNames(!darkMode ? styles.tradeAnimation : '', styles.tradeTheme)} style={{marginLeft:'0.8em', color: '#fa0', cursor: 'pointer'}} 
                                onClick={() => {
                                    setDarkMode(!darkMode)
                                    setTimeout(() => {
                                        setTradeTheme(false);
                                    }, 1000);
                                    }}
                                />
                            )}
                            
                        </div>
                            <ul className={styles.container_list}>
                                <li className={styles.container_item}>
                                    <Link 
                                    to='home' 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100} 
                                    className={classNames(styles.navItem, !darkMode ? 'dot-light' : 'dot-dark')}
                                    onSetActive={handleSetActiveSection}
                                    spy={true}
                                    activeClass={activeSection === "home" ? "active" : ""}
                                    style={{ '--i': 1, color: DarkModeTextColorPrimary }}
                                    >
                                <FontAwesomeIcon icon={faHouseChimney} style={{color: DarkModeTextColorPrimary ,marginLeft: '0.5em'}} /> Home</Link>
                                </li>

                                <li className={styles.container_item} >
                                    <Link 
                                    to="about" 
                                    smooth={true} 
                                    duration={500} 
                                    offset={-100}   
                                    className={classNames(styles.navItem, !darkMode ? 'dot-light' : 'dot-dark')}
                                    onSetActive={handleSetActiveSection}
                                    spy={true}
                                    activeClass={activeSection === "about" ? "active" : ""}
                                    style={{ '--i': 2, color: DarkModeTextColorPrimary }}
                                    >
                                <FontAwesomeIcon icon={faAddressCard} style={{color: DarkModeTextColorPrimary ,marginLeft: '0.5em'}} /> About</Link>
                                </li>

                                <li className={styles.container_item} >
                                    <Link 
                                    className={classNames(styles.navItem, !darkMode ? 'dot-light' : 'dot-dark')} 
                                    to="skils" 
                                    smooth={true} 
                                    offset={-110} 
                                    duration={500}
                                    onSetActive={handleSetActiveSection}
                                    spy={true}
                                    activeClass={activeSection === "skils" ? "active" : ""}
                                    style={{ '--i': 3, color: DarkModeTextColorPrimary }}
                                >
                                <FontAwesomeIcon icon={faTrophy} style={{color: DarkModeTextColorPrimary ,marginLeft: '0.5em'}} /> Skils</Link>
                                </li>

                                <li className={styles.container_item} >
                                    <Link 
                                    className={classNames(styles.navItem, !darkMode ? 'dot-light' : 'dot-dark')} 
                                    to="projects" 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100} 
                                    onSetActive={handleSetActiveSection}
                                    spy={true}
                                    activeClass={activeSection === "projects" ? "active" : ""}
                                    style={{ '--i': 4, color: DarkModeTextColorPrimary }}
                                >
                            <FontAwesomeIcon icon={faImages} style={{color: DarkModeTextColorPrimary ,marginLeft: '0.5em'}} /> Projects</Link>
                                </li>

                                <li className={styles.container_item} >
                                    <Link 
                                    onMouseEnter={() => onMouseEnterEffect()} 
                                    onMouseLeave={() => onMouseLeaveEffect()} 
                                    id={styles.contact}
                                    className={classNames(styles.navItem, !darkMode ? 'dot-light' : 'dot-dark')} 
                                    to="contact" 
                                    smooth={true} 
                                    duration={500}
                                    offset={-100} 
                                    onSetActive={handleSetActiveSection}
                                    spy={true}
                                    activeClass={activeSection === "contact" ? "active" : ""}
                                    style={{ '--i': 5, color: darkMode ? ' #FFFFFF' : '', border: darkMode ? '3px solid #ffffff' : '',marginTop: '0.2em'}}
                                > 
                                    <HiChatAlt2 
                                    icon={faMessage} 
                                    style={{color: calcHoverColor(), transition: '2s',marginRight: '0.2em', fontSize: '1.1em', display: 'inline-block'}}
                                    />Contact Me </Link>
                                </li>
                            </ul>
                        </nav>
                    </aside>

                            <input 
                                onClick={() => {
                                setDarkMode(!darkMode)
                                }}
                                id={styles.toggle} 
                                className={styles.toggle} 
                                type="checkbox"/>
                                
                                    <ul className={classNames(styles.navigation, activeNavBar ? styles.active_nav_bar : '')}>
                                        <li className={styles.li}>
                                            <Link
                                                to='home' 
                                                smooth={true} 
                                                duration={500}
                                                offset={-100} 
                                                className={classNames(styles.a,  !darkMode ? 'dot-light' : 'dot-dark')}
                                                onSetActive={handleSetActiveSection}
                                                spy={true}
                                                activeClass={activeSection === "home" ? "active" : ""}
                                                style={{ '--i': 1, color: "#4d4d4d" }}
                                                ><FontAwesomeIcon className={styles.nav_icon} icon={faHouseChimney} style={{color:"#4d4d4d" ,margin: '0 0.5em',fontSize: '0.8em'}} />Home
                                            </Link>
                                        </li>
                                        <li>
                                            <Link 
                                                to="about" 
                                                smooth={true} 
                                                duration={500} 
                                                offset={-100}   
                                                className={classNames(styles.a, !darkMode ? 'dot-light' : 'dot-dark')}
                                                onSetActive={handleSetActiveSection}
                                                spy={true}
                                                activeClass={activeSection === "about" ? "active" : ""}
                                                style={{ '--i': 2, color:  "#4d4d4d" }}
                                                ><FontAwesomeIcon className={styles.nav_icon} icon={faAddressCard} style={{color: "#4d4d4d" ,margin: '0 0.5em',fontSize: '0.8em'}} />About
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="skils" 
                                                className={classNames(styles.a, !darkMode ? 'dot-light' : 'dot-dark')} 
                                                smooth={true} 
                                                offset={-110} 
                                                duration={500}
                                                onSetActive={handleSetActiveSection}
                                                spy={true}
                                                activeClass={activeSection === "skils" ? "active" : ""}
                                                style={{ '--i': 3, color: "#4d4d4d" }}
                                                ><FontAwesomeIcon className={styles.nav_icon} icon={faTrophy} style={{color: "#4d4d4d" ,margin: '0 0.5em',fontSize: '0.8em'}} />Skils
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="projects" 
                                                className={classNames(styles.a, !darkMode ? 'dot-light' : 'dot-dark')} 
                                                smooth={true} 
                                                duration={500}
                                                offset={-100} 
                                                onSetActive={handleSetActiveSection}
                                                spy={true}
                                                activeClass={activeSection === "projects" ? "active" : ""}
                                                style={{ '--i': 4, color: "#4d4d4d" }}
                                                ><FontAwesomeIcon className={styles.nav_icon} icon={faImages} style={{color: "#4d4d4d" ,margin: '0 0.5em',fontSize: '0.8em'}} />Projects
                                            </Link>
                                        </li>
                                        <li>
                                            <Link 
                                                className={classNames(styles.a, !darkMode ? 'dot-light' : 'dot-dark')} 
                                                to="contact" 
                                                smooth={true} 
                                                duration={500}
                                                offset={-100} 
                                                onSetActive={handleSetActiveSection}
                                                spy={true}
                                                activeClass={activeSection === "contact" ? "active" : ""}
                                                style={{ '--i': 5, color: "#4d4d4d" }}
                                                >
                                                <HiChatAlt2
                                                className={styles.nav_icon}
                                                icon={faMessage} 
                                                style={{color: "#4d4d4d" ,margin: '0 0.4em', fontSize: '1em',}} 
                                                />Contact Me
                                            </Link>
                                        </li>
                                    <span className={`${styles.toggleMenu} ${darkMode ?  styles.toggleMenuDarkMode : ''}`} onClick={() => setActiveNavBar(!activeNavBar)}></span>
                                </ul>

                        
            </header>
        </section>
    )
}
